import { Calendar, FileQuestion, FolderX } from 'lucide-react'
import { useBrowseCalendars } from '@/hooks/usePlanBrowse'
import { FolderCard } from './FolderCard'
import { FolderGrid, FolderGridSkeleton } from './FolderGrid'
import type { BrowseCalendarSelection } from '@/stores/useBrowseStore'

interface CalendarGridProps {
  departmentId: string
  onSelect: (calendar: BrowseCalendarSelection) => void
}

export function CalendarGrid({ departmentId, onSelect }: CalendarGridProps) {
  const { data, isLoading } = useBrowseCalendars(departmentId)

  const calendars = data?.data ?? []

  if (isLoading) return <FolderGridSkeleton label="Loading calendars" />

  if (calendars.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center gap-2 py-16 text-muted-foreground">
        <FolderX className="h-10 w-10" />
        <p className="text-sm">No calendars found</p>
      </div>
    )
  }

  return (
    <FolderGrid>
      {calendars.map(cal => {
        const isNoCalendar = cal.calendar_id === null
        return (
          <FolderCard
            key={cal.calendar_id ?? 'no-calendar'}
            icon={
              isNoCalendar ? (
                <FileQuestion className="h-6 w-6" />
              ) : (
                <Calendar className="h-6 w-6" />
              )
            }
            title={cal.calendar_name}
            subtitle={`${cal.plan_count} plan${cal.plan_count !== 1 ? 's' : ''}`}
            onClick={() =>
              onSelect({
                calendarId: cal.calendar_id,
                calendarName: cal.calendar_name,
                isSeasonal: cal.is_seasonal,
                noCalendar: isNoCalendar,
              })
            }
          />
        )
      })}
    </FolderGrid>
  )
}
